import { Pipe, PipeTransform } from "@angular/core";
import { formatPhoneNumber } from "~/app/core/util/string-util";

@Pipe({name: "phone"})
export class PhoneFormatPipe implements PipeTransform {
    transform(value: string): string {
        return formatPhoneNumber(value);
    }
}
